/**
 * Screen-level section-layout defaults merge (v2.19.0).
 *
 * `FlexibleLayoutConfig.defaultSectionLayout` is shallow-merged UNDER each
 * section's own layout — any field the section sets explicitly wins whole
 * (no deep merge: a section's own `padding` object fully replaces the default
 * `padding`). In scrollable mode flexGrow/flexShrink are zeroed AFTER the
 * merge because flex sizing is meaningless in a scroll column.
 */

import type { SectionLayout } from '@segmently/schema-models/v2';

export function mergeSectionLayout(
  defaultSectionLayout: Record<string, unknown> | undefined,
  sectionLayout: SectionLayout | undefined,
  scrollable: boolean,
): SectionLayout | undefined {
  const mergedLayout = defaultSectionLayout
    ? ({ ...defaultSectionLayout, ...(sectionLayout ?? {}) } as SectionLayout)
    : sectionLayout;

  if (scrollable && mergedLayout) {
    return { ...mergedLayout, flexShrink: 0, flexGrow: 0 };
  }
  return mergedLayout;
}
